import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Default fallback image shown on all blog cards when heroImage is missing,
 * empty, or fails to load (onError). 26 KB JPEG, 900×506px.
 */
export const BLOG_FALLBACK_IMAGE = "/media/blog-fallback-hero-opt_0ca15040.jpg";

/**
 * Returns the heroImage URL if truthy, otherwise the branded fallback.
 * Use in src= props; pair with onError={handleBlogImageError} for runtime 404s.
 */
export function getBlogImage(heroImage?: string | null): string {
  return heroImage?.trim() ? heroImage : BLOG_FALLBACK_IMAGE;
}

/**
 * onError handler for <img> tags - swaps in the fallback on any load failure.
 * Prevents infinite error loops by checking the src hasn't already been replaced.
 */
export function handleBlogImageError(
  e: React.SyntheticEvent<HTMLImageElement, Event>
): void {
  const img = e.currentTarget;
  if (img.src !== window.location.origin + BLOG_FALLBACK_IMAGE) {
    img.src = BLOG_FALLBACK_IMAGE;
  }
}
